import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { FaSearch, FaUserShield, FaUserSlash, FaUserCheck } from "react-icons/fa";

const UsersDashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmAction, setConfirmAction] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/users", {
        params: { page, pageSize, search },
      });
      setUsers(res.data.items);
      setTotalCount(res.data.totalCount);
    } catch (err) {
      console.error("İstifadəçilər alınmadı", err);
      toast.error("İstifadəçiləri yükləmək mümkün olmadı!");
    } finally {
      setLoading(false);
    }
  };

  const assignRole = async (userId, role) => {
    try {
      await api.post("/admin/assign-role", { userId, role });
      toast.success(`Rol "${role}" olaraq dəyişdirildi`);
      fetchUsers();
    } catch (err) {
      toast.error(err.response?.data?.message || "Rol dəyişdirilə bilmədi");
    }
  };

  const toggleBan = async (userId, isBanned) => {
    try {
      await api.post(`/admin/toggle-ban/${userId}`);
      toast.success(`İstifadəçi ${isBanned ? "aktiv edildi" : "banlandı"}`);
      fetchUsers();
    } catch (err) {
      toast.error(err.response?.data?.message || "Əməliyyat uğursuz oldu");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, search]);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    setPage(1);
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  if (loading) {
    return (
      <div className="hy-users-loading">
        <div className="hy-users-spinner" />
        <p>Yüklənir...</p>
      </div>
    );
  }

  return (
    <div className="hy-users-container">
      <div className="hy-users-header">
        <div className="hy-users-title-section">
          <h2 className="hy-users-title">
            <FaUserShield /> İstifadəçilərin İdarəsi
          </h2>
          <p className="hy-users-count">Ümumi: <strong>{totalCount}</strong> istifadəçi</p>
        </div>

        <form onSubmit={handleSearch} className="hy-users-search-form">
          <div className="hy-users-search-wrapper">
            <FaSearch className="hy-users-search-icon" />
            <input
              type="text"
              placeholder="Ad, email və ya telefon ilə axtar..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="hy-users-search-input"
            />
          </div>
          <button type="submit" className="hy-users-search-btn">
            Axtar
          </button>
        </form>
      </div>

      <div className="hy-users-table-wrapper">
        <table className="hy-users-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Ad Soyad</th>
              <th>Email</th>
              <th>Telefon</th>
              <th>Rol</th>
              <th>Qeydiyyat</th>
              <th>Status</th>
              <th>Rol Təyini</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, idx) => (
              <tr key={user.id}>
                <td className="hy-users-cell-number">{(page - 1) * pageSize + idx + 1}</td>
                <td className="hy-users-cell-name">{user.fullName}</td>
                <td className="hy-users-cell-email">{user.email}</td>
                <td className="hy-users-cell-phone">{user.phoneNumber || "—"}</td>
                <td>
                  <span className={`hy-users-role-badge hy-users-role-${user.role}`}>
                    {user.role}
                  </span>
                </td>
                <td className="hy-users-cell-date">
                  {new Date(user.createdAt).toLocaleDateString("az-AZ")}
                </td>
                <td>
                  {user.isBanned ? (
                    <span className="hy-users-status-banned">
                      <FaUserSlash /> Banlı
                    </span>
                  ) : (
                    <span className="hy-users-status-active">
                      <FaUserCheck /> Aktiv
                    </span>
                  )}
                </td>
                <td>
                  {user.role === "admin" ? (
                    <span className="hy-users-disabled-text">admin</span>
                  ) : (
                    <select
                      value={user.role}
                      onChange={(e) => assignRole(user.id, e.target.value)}
                      className="hy-users-role-select"
                    >
                      <option value="user">user</option>
                      <option value="moderator">moderator</option>
                    </select>
                  )}
                </td>
                <td>
                  {user.role === "admin" ? (
                    <span className="hy-users-disabled-text">—</span>
                  ) : (
                    <button
                      className={user.isBanned ? "hy-users-btn-activate" : "hy-users-btn-ban"}
                      onClick={() =>
                        setConfirmAction({ userId: user.id, isBanned: user.isBanned })
                      }
                    >
                      {user.isBanned ? "Aktiv Et" : "Ban Et"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="hy-users-pagination">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className="hy-users-pagination-arrow"
          >
            ← Əvvəlki
          </button>
          
          <div className="hy-users-pagination-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (page <= 3) {
                pageNum = i + 1;
              } else if (page >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = page - 2 + i;
              }
              
              return (
                <button
                  key={pageNum}
                  onClick={() => setPage(pageNum)}
                  className={`hy-users-pagination-btn ${page === pageNum ? 'active' : ''}`}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>

          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="hy-users-pagination-arrow"
          >
            Sonrakı →
          </button>
        </div>
      )}

      {confirmAction && (
        <div className="hy-users-modal-overlay">
          <div className="hy-users-modal">
            <h3 className="hy-users-modal-title">Təsdiqlə</h3>
            <p className="hy-users-modal-text">
              Bu istifadəçini <strong>{confirmAction.isBanned ? "aktiv etmək" : "banlamaq"}</strong> istədiyinizə əminsiniz?
            </p>
            <div className="hy-users-modal-actions">
              <button
                onClick={() => {
                  toggleBan(confirmAction.userId, confirmAction.isBanned);
                  setConfirmAction(null);
                }}
                className="hy-users-modal-btn-confirm"
              >
                Bəli
              </button>
              <button
                onClick={() => setConfirmAction(null)}
                className="hy-users-modal-btn-cancel"
              >
                Xeyr
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersDashboard;